import { Box, Typography } from "@mui/material";
import { CollapsibleBox } from "../components/CollapsibleBox.tsx";

const Organization = () => (
  <Box>
    <Typography variant={"h2"}>Organization</Typography>
    <Typography variant={"body1"} mb={2}>
      Let’s get you on the map to understand your eGrid emission factors and
      other important location-based factors that will help you optimize your
      planning.
    </Typography>
    <CollapsibleBox
      copy1={"Setup your company information."}
      copy2={""}
      title={"Sites"}
      subtitle={""}
      linkPath={"/sites"}
      linkText={"Add Sites"}
    />
  </Box>
);

export default Organization;
